import { checkHttpStatus, parseJSON, objectToQueryString, expiredToken } from '../../../utils/response';
import { Token, UserCode, Company, EmployeeCode } from '../../../utils/users';
import { errorResponse } from '../../../utils/response';
import { IsEnglish } from '../../../utils/language';

export function provinceExpense() {
    let url = 'expenseAccount/provinces?' + objectToQueryString({ Company: Company(), EmployeeCode: EmployeeCode(), userCode: UserCode(), token: Token() });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                let provinces = response.provinces;

                //saveProvinces(provinces);

                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function sortProvince(data) {
    return data.sort(function (a, b) {
        const nameA = IsEnglish() ? a.provinceNameE.toLowerCase() : a.provinceNameF.toLowerCase()
        const nameB = IsEnglish() ? b.provinceNameE.toLowerCase() : b.provinceNameF.toLowerCase()
        if (nameA < nameB) //sort string ascending
            return -1
        if (nameA > nameB)
            return 1
        return 0 //default return value (no sorting)
    });
}

function saveProvinces(config) {
    localStorage.setItem('expenseProvinces', JSON.stringify(config));
}